import algoliaClient from "@herb/clients/algolia";

const products = algoliaClient.initIndex("Products");

export default { products };
